var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 8.4915H14.6749C12.6999 8.4915 11.0916 6.88317 11.0916 4.90817V2.49984C11.0916 2.0415 10.7166 1.6665 10.2583 1.6665H6.72492C4.15825 1.6665 2.08325 3.33317 2.08325 6.30817V13.6915C2.08325 16.6665 4.15825 18.3332 6.72492 18.3332H13.2749C15.8416 18.3332 17.9166 16.6665 17.9166 13.6915V9.32484C17.9166 8.8665 17.5416 8.4915 17.0833 8.4915Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 1.84158C12.8251 1.49991 12.2334 1.73325 12.2334 2.20825V5.11658C12.2334 6.33325 13.2667 7.34158 14.5251 7.34158C15.3167 7.34991 16.4167 7.34991 17.3584 7.34991C17.8334 7.34991 18.0834 6.79158 17.7501 6.45825C16.5501 5.24991 14.4001 3.07491 13.1667 1.84158Z",
    fill: "#838B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.4585H6.25C5.90833 11.4585 5.625 11.1752 5.625 10.8335C5.625 10.4918 5.90833 10.2085 6.25 10.2085H11.25C11.5917 10.2085 11.875 10.4918 11.875 10.8335C11.875 11.1752 11.5917 11.4585 11.25 11.4585Z",
    fill: "#838B9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 14.7915H6.25C5.90833 14.7915 5.625 14.5082 5.625 14.1665C5.625 13.8248 5.90833 13.5415 6.25 13.5415H9.58333C9.925 13.5415 10.2083 13.8248 10.2083 14.1665C10.2083 14.5082 9.925 14.7915 9.58333 14.7915Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.f07ba95dac4519653e1cccc41b996cdb.svg";
export { ForwardRef as ReactComponent };